import * as React from 'react'
import { useContext } from 'react'
import DynamicTable from 'Components/DynamicTable/DynamicTable'
import FilterSearchDocuments from './FiltersSearchDocuments/FilterSearchDocumentsReturn'
import SearchDocumentsPagination from './SearchDocumentsPagination/SearchDocumentsPagination'
import MiniLoading from 'Components/MiniLoading'

import { SearchDocumentsVadIvendContext } from 'state/context/SearchDocumentsVadIvendContext'
import { SearchSalesDocumentsContext } from 'state/context/SearchSalesDocumentsContext'

function useUnifiedSearchContext() {
  const salesDocumentsContext = useContext(SearchSalesDocumentsContext)
  const vadIvendContext = useContext(SearchDocumentsVadIvendContext)
  return salesDocumentsContext || vadIvendContext
}

export function TableSearchDocuments({
  columns,
  FilterComponent,
  PaginationComponent,
}) {
  const context = useUnifiedSearchContext()

  if (!context) {
    throw new Error(
      'TableSearchDocuments must be used within a search documents provider'
    )
  }

  const { dataDocuments, loadingData, loadingScope } = context
  const useTableLoading = loadingScope === 'table'

  const FilterToRender = FilterComponent || FilterSearchDocuments
  const PaginationToRender = PaginationComponent || SearchDocumentsPagination

  return (
    <>
      {loadingData && !useTableLoading ? (
        <MiniLoading noMargin style={{ padding: '60px 0' }} />
      ) : (
        <div
          className="search-invoice-content"
          data-testid="container-search-documents">
          <FilterToRender />
          <div>
            <DynamicTable
              columns={columns}
              data={dataDocuments}
              loadingData={useTableLoading ? loadingData : false}
            />
          </div>
          <div className="search-invoice-footer">
            <PaginationToRender />
          </div>
        </div>
      )}
    </>
  )
}
